export const AUTH_STATUS = {
  LOADING: "loading",
  AUTHENTICATED: "authenticated",
  UNAUTHENTICATED: "unauthenticated",
} as const;

export type AuthStatus = (typeof AUTH_STATUS)[keyof typeof AUTH_STATUS];

export const SHELL_VARIANTS = {
  GUEST: "guest",
  ADMIN: "admin",
  LOADING: "loading",
} as const;

export type ShellVariant = (typeof SHELL_VARIANTS)[keyof typeof SHELL_VARIANTS];
